export default {
  isAuthenticated: state => !!state.token,
  accessToken: state => (state.token ? state.token.access_token : null),
  tokenType: state => (state.token ? state.token.token_type : null),
  expiresIn: state => (state.token ? state.token.expires_in : null),
  authStatus: state => state.status
};
